import {datadogRum} from '@datadog/browser-rum';
import {describeAuthError} from 'services/auth-errors';

const toBoolean = (value) => value === true || value === 'true';
let isDatadogRumReady = false;
const toNumber = (value, fallback) => {
  const parsed = Number(value);
  return isNaN(parsed) ? fallback : parsed;
};
const ENV = typeof window !== 'undefined' ? window.env : null;

export const initDatadog = () => {
  if (!ENV) {
    console.warn('Datadog RUM not initialized: environment is not available.');
    return;
  }

  if (!toBoolean(ENV?.REACT_APP_DATADOG_ENABLED)) {
    console.warn('Datadog RUM is disabled in this environment.');
    return;
  }

  const clientToken = ENV?.REACT_APP_DATADOG_CLIENT_TOKEN;
  const applicationId = ENV?.REACT_APP_DATADOG_APPLICATION_ID;

  if (!clientToken || !applicationId) {
    console.warn('Datadog RUM not initialized: missing client token or application ID.');
    return;
  }

  datadogRum.init({
    clientToken,
    applicationId,
    site: ENV?.REACT_APP_DATADOG_SITE || 'datadoghq.com',
    service: ENV?.REACT_APP_DATADOG_SERVICE,
    env: ENV?.REACT_APP_DATADOG_ENV,
    version: ENV?.REACT_APP_DATADOG_VERSION,
    sessionSampleRate: toNumber(ENV?.REACT_APP_DATADOG_SESSION_SAMPLE_RATE, 100),
    sessionReplaySampleRate: toNumber(ENV?.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE, 20),
    trackUserInteractions: toBoolean(ENV?.REACT_APP_DATADOG_TRACK_USER_INTERACTIONS),
    trackResources: toBoolean(ENV?.REACT_APP_DATADOG_TRACK_RESOURCES),
    trackLongTasks: toBoolean(ENV?.REACT_APP_DATADOG_TRACK_LONG_TASKS),
    defaultPrivacyLevel: 'mask-user-input',
  });
  isDatadogRumReady = true;
};

export const reportDatadogError = (error, context = {}) => {
  if (!isDatadogRumReady) {
    return;
  }

  try {
    // The second argument of addError is the custom context itself (not a wrapper object).
    datadogRum.addError(error, {
      ...context,
      origin: window.location?.origin,
      inIframe: typeof window !== 'undefined' && window.top !== window.self,
    });
  } catch (reportError) {
    console.warn('Datadog RUM failed to record error', reportError);
  }
};

export const reportDatadogAuthError = (error, extraContext = {}) => {
  const auth = describeAuthError(error);
  const rumError = error instanceof Error ? error : new Error(auth.message);

  if (!rumError.message?.trim()) {
    rumError.message = auth.message;
  }

  reportDatadogError(rumError, {auth, ...extraContext});
};
